// extracted by mini-css-extract-plugin
export default {"login":"Layout_login__ZasUj","content":"Layout_content__PWopC","layout":"Layout_layout__EBPPQ","footer":"Layout_footer__K8scF","bold":"Layout_bold__pwuBR"};